// The number behind a dealer phone sign-in that is in flight. Login records
// it just before trading the OTP for a session, and the shell reads it once
// (App.js) to tell an OTP sign-in that has no dealer account, which is
// answered on the sign-in page, apart from any other session without a role,
// which gets the no-access screen.
let pendingPhone = null;

export function markPhoneSignIn(phone) {
  pendingPhone = phone;
}

export function takePhoneSignIn() {
  const phone = pendingPhone;
  pendingPhone = null;
  return phone;
}
